export const content = "BetterHelp clients must be 18 or older. We\u2019re unable to provide care for children or teens 17 or younger.\n";
